module.exports = __webpack_public_path__ + "static/media/SF-13-A (1).9103d1fe.mp3";